<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">Test EIAJ后端生成pdf</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-text-field placeholder="输入doId" v-model="doId"/>
        <v-btn @click="pdfBuild" color="success">下载</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      doId: null
    }
  },
  methods: {
    pdfBuild() {
      return this.$download(`/delivery-orders/${this.doId}/eiajs.pdf`)
    }
  }
}
</script>



